
export const RouteTypes = {
  NOT_FOUND: '*',
  BASE: '/',
  LOGIN: '/login',
  SET_PASSWORD: '/login/:id/:code/set-password',
  SET_PASSWORD_LOGGED: '/:id/:code/set-password',
  RESET_PASSWORD: '/login/:id/:code/reset-password',
  RESET_PASSWORD_LOGGED: '/:id/:code/reset-password',
  FORCE_UPDATE_PASSWORD: '/login/update-password',
  DASHBOARD: '/dashboard',
  NOTIFICATIONS: '/notifications',
  DAIRY_FACTORY: '/dairy',
  PROFILE: '/profile',
  CLOUD_STORAGE: '/cloud-storage',
  MILK_SAMPLES: '/milk-samples',
  FARM_MILK_DELIVERY: '/far-milk-money/milk-delivery',
  FARM_MILK_QUALITY: '/far-milk-money/milk-quality',
  FARM_MILK_MILK_MONEY: '/far-milk-money/milk-money',
  MILK_MONEY_INVOICE: '/milk-money/invoice',
  MILK_MONEY_INVOICE_EDIT: '/milk-money/invoice/:id/edit',
  MILK_MONEY_TOUR_PLANNING: '/milk-money/tour-planning',
  MILK_MONEY_DELIVERY: '/milk-money/delivery',
  MILK_MONEY_MGA_FACTORS: '/milk-money/mga-factors',
  MILK_MONEY_FTP_LOGS: '/milk-money/ftp-logs',
  MILK_MONEY_SAMPLES_INDIVIDUAL: '/milk-money/samples/:id',
  MILK_MONEY_SAMPLES_FARMER: '/milk-money/samples/:id',
  MILK_MONEY_SAMPLES_DAIRY: '/milk-money/samples/:id',
  MILK_MONEY_SAMPLES_PSEUDOM: '/milk-money/samples/:id',
  MILK_MONEY_SAMPLES_SHOW: '/milk-money/samples/:sampleType/show/:id',
  MILK_MONEY_TOURS_IMPORT: '/milk-money/tours-import',
  MILK_MONEY_TOURS_SHOW: '/milk-money/tours/:id/show',
  SETTINGS_CLOUD_STORAGE: '/settings/cloud-storage',
  SETTINGS_FTP: '/settings/ftp',
  SETTINGS_FTP_LOGS: '/settings/logs-ftp',
  CO2_CLIMATE: '/co2-climate',
  CO2_CLIMATE_CREATE: '/co2-climate/create',
  CO2_CLIMATE_EDIT: '/co2-climate/:id/edit',
  CO2_CLIMATE_SHOW: '/co2-climate/:id/show',
  CO2_CLIMATE_RESULTS: '/co2-climate/:id/results',
  CO2_CLIMATE_ANSWER: '/co2-climate/:id/answer',
  CO2_CLIMATE_SUB_FARMER_ANSWER: '/co2-climate/:id/answer/:farmerId',
  CO2_CLIMATE_EDIT_ANSWER: '/co2-climate/:id/edit/answer',
  CO2_CLIMATE_EDIT_SUB_FARMER_ANSWER: '/co2-climate/:id/edit/:farmerId/answer',
  CO2_CLIMATE_DRAFT_ANSWER: '/co2-climate/:id/draft/answer',
  CO2_CLIMATE_DRAFT_SUB_FARMER_ANSWER: '/co2-climate/:id/draft/:farmerId/answer',
  CLIMATE_CHECK: '/climate-check',
  CLIMATE_CHECK_CREATE: '/climate-check/create',
  CLIMATE_CHECK_EDIT: '/climate-check/:id',
  CLIMATE_CHECK_SHOW: '/climate-check/:id/show',
  CLIMATE_CHECK_RESULTS: '/climate-check/:id/results',
  CLIMATE_CHECK_ANSWER: '/climate-check/:id/answer',
  CLIMATE_CHECK_EDIT_ANSWER: '/climate-check/:id/edit/answer',
  CLIMATE_CHECK_SUB_FARMER_ANSWER: '/climate-check/:id/answer/:farmerId',
  CLIMATE_CHECK_EDIT_SUB_FARMER_ANSWER: '/climate-check/:id/edit/:farmerId/answer',
  CLIMATE_CHECK_DRAFT_ANSWER: '/climate-check/:id/draft/answer',
  CLIMATE_CHECK_DRAFT_SUB_FARMER_ANSWER: '/climate-check/:id/draft/:farmerId/answer',
  COOL_FARM: '/cool-farm',
  CLIMA_PROGRAM: '/clima-program',
  CLIMA_PROGRAM_FEED_PURCHASES: '/clima-program/feed-purchases',
  CLIMA_PROGRAM_FEED_PURCHASES_CREATE: '/clima-program/create',
  CLIMA_PROGRAM_FEED_PURCHASES_EDIT: '/clima-program/edit/:id',
  COOL_FARM_ANSWER_DAIRY: '/cool-farm/dairy/:id/answer',
  COOL_FARM_ANSWER_CROP: '/cool-farm/crop/:id/answer',
  COOL_FARM_EDIT_CROP: '/cool-farm-tool/:id/crops/:idCrop/edit',
  PROFILE_SETTINGS: '/profile-settings',
  FARMER_PROFILE: '/farmer-profile',
  DAIRY_FACTORY_PROFILE: '/dairy/profile',
  DAIRY_FACTORY_PROFILE_USERS: '/dairy/profile/users',
  DAIRY_FACTORY_STONE_X_BLE: '/dairy/profile/stone-x-ble',
  DAIRY_FACTORY_STONE_X_BLE_CREATE: '/dairy/profile/stone-x-ble/create',
  DAIRY_FACTORY_STONE_X_BLE_EDIT: '/dairy/profile/stone-x-ble/:id/edit',
  DAIRY_FACTORY_PROFILE_FARMER_GROUPS: '/dairy/profile/farmer-groups',
  DAIRY_FACTORY_PROFILE_FARMER_GROUPS_SHOW: '/dairy/profile/farmer-groups/show/:id',
  DAIRY_FACTORY_PROFILE_LOCATIONS: '/dairy/profile/locations',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS: '/dairy/profile/individual-filters',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GENERAL: '/dairy/profile/individual-filters/general',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GENERAL_CREATE: '/dairy/profile/individual-filters/general/create',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GENERAL_EDIT: '/dairy/profile/individual-filters/general/:id/edit',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GEOGRAPHICAL: '/dairy/profile/individual-filters/geographical',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GEOGRAPHICAL_CREATE: '/dairy/profile/individual-filters/geographical/create',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_GEOGRAPHICAL_EDIT: '/dairy/profile/individual-filters/geographical/:id/edit',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT: '/dairy/profile/individual-filters/amount',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT_CREATE: '/dairy/profile/individual-filters/amount/create',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT_EDIT: '/dairy/profile/individual-filters/amount/:id/edit',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_RADIUS: '/dairy/profile/individual-filters/radius',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_RADIUS_CREATE: '/dairy/profile/individual-filters/radius/create',
  DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_RADIUS_EDIT: '/dairy/profile/individual-filters/radius/:id/edit',
  DAIRY_FACTORY_PROFILE_BANKS: '/dairy/profile/banks',
  DAIRY_FACTORY_PROFILE_VAT: '/dairy/profile/vat',
  DAIRY_FACTORY_PROFILE_BASE_PRICE: '/dairy/profile/base-price',
  DAIRY_FACTORY_PROFILE_BANKS_CREATE: '/dairy/profile/banks/create',
  DAIRY_FACTORY_PROFILE_BANKS_EDIT: '/dairy/profile/banks/edit/:id',
  DAIRY_FACTORY_PROFILE_DISTRICTS: '/dairy/profile/districts',
  DAIRY_FACTORY_PROFILE_HUSBANDRY: '/dairy/profile/husbandry',
  DAIRY_FACTORY_PROFILE_SHOP: '/dairy/profile/shop-managment',
  DAIRY_FACTORY_PROFILE_SHOP_CREATE: '/dairy/profile/shop-managment/create',
  DAIRY_FACTORY_PROFILE_SHOP_EDIT: '/dairy/profile/shop-managment/edit/:id',
  DAIRY_FACTORY_PROFILE_MILK_TYPES: '/dairy/profile/milk-types',
  DAIRY_FACTORY_PROFILE_MILK_PAYMENT: '/dairy/profile/milk-payment',
  DAIRY_FACTORY_FARMERS: '/dairy/farmers',
  DAIRY_FACTORY_FARMERS_EDIT: '/dairy/farmers/edit/:id',
  DAIRY_FACTORY_FARMERS_MGA_ATTACHMENTS: '/dairy/farmers/:id/mga-attachments',
  DAIRY_FACTORY_FARMERS_MGA_ATTACHMENT_CREATE: '/dairy/farmers/:id/mga-attachment/create',
  DAIRY_FACTORY_FARMERS_SHOW: '/dairy/farmers/show/:id',
  DAIRY_FACTORY_FARMERS_CREATE: '/dairy/farmers/create',
  DAIRY_FACTORY_FARMER_USERS: '/dairy/farmer-users',
  DAIRY_FACTORY_FARMER_USERS_CREATE: '/dairy/farmer-users/:id/create',
  DAIRY_FACTORY_FARMER_GROUPS_CREATE: '/dairy/farmer-groups/create',
  DAIRY_FACTORY_FARMER_GROUPS_EDIT: '/dairy/farmer-groups/edit/:id',
  DAIRY_FACTORY_FARMER_GROUPS_SHOW: '/dairy/farmer-groups/show/:id',
  DAIRY_FACTORY_PRICE_ACTIVITY_LOGS: '/dairy/activity-logs',
  DAIRY_FACTORY_PRICE_ACTIVITY_LOGS_HISTORY: '/dairy/activity-logs/history',
  FARMER_USERS_EDIT: '/dairy/:farmerId/farmer-users/:id',
  REPORTING_ARTICLE_BOOKINGS: '/reporting/article-bookings',
  REPORTING_DISTRICT_DELIVERY: '/reporting/district-delivery',
  REPORTING_DISTRICT_DELIVERY_DETAILS: '/reporting/district-delivery/:id/details',
  REPORTING_CO2: '/reporting/co2',
  REPORTING_CLIMA_CHECK: '/reporting/clima-check',
  REPORTING_TRADING_ACTIVITIES: '/reporting/:prefix/trading-activities',
  REPORTING_PRICE: '/reporting/:prefix/price',
  SETTINGS: '/settings',
  SETTINGS_TRADING_SLOT: '/settings/trading-slot',
  SETTINGS_CO2_CLIMATE: '/settings/co2-climate',
  SETTINGS_SECURITY: '/settings/security',
  SETTINGS_MILK_MONEY: '/settings/milk-money',
  SETTINGS_VAT: '/settings/vat',
  SETTINGS_GENERAL: '/settings/general',
  SETTINGS_LOGIN_POPUP: '/settings/login-popup',
  SETTINGS_LOGIN_POPUP_CREATE: '/settings/login-popup/create',
  SETTINGS_LOGIN_POPUP_EDIT: '/settings/login-popup/edit/:id',
  SEETINGS_MESSAGE: 'settings/message',
  SETTINGS_CLIMA_CHECK: 'settings/kpm',
  MILK_FIXED_PRICE: '/milk-fixed-price',
  MILK_FIXED_PRICE_CREATE: '/milk-fixed-price/create',
  MILK_FIXED_PRICE_SHOW: '/milk-fixed-price/show/:id',
  PREFIX_TRADING_SLOT_SHOW: '/:prefix/show/:id',
  PREFIX_TRADING_SLOT_RESULTS: '/:prefix/results/:id',
  PREFIX_TRADING_SLOT_OFFER_AMOUNT: '/:prefix/offer-amount/:id',
  MILK_FIXED_PRICE_EDIT: '/milk-fixed-price/edit/:id',
  MILK_FIXED_PRICE_RESULTS: '/milk-fixed-price/results/:id',
  MILK_FIXED_PRICE_OFFERS_PREVIEW: '/milk-fixed-price/offers-preview/:id',
  MILK_FIXED_PRICE_OFFER_AMOUNT: '/milk-fixed-price/offer-amount/:id',
  STOCK_EXCHANGE: '/stock-exchange',
  STOCK_EXCHANGE_CREATE: '/stock-exchange/create',
  STOCK_EXCHANGE_SHOW: '/stock-exchange/show/:id',
  STOCK_EXCHANGE_EDIT: '/stock-exchange/edit/:id',
  STOCK_EXCHANGE_RESULTS: '/stock-exchange/results/:id',
  STOCK_EXCHANGE_OFFERS_PREVIEW: '/stock-exchange/offers-preview/:id',
  STOCK_EXCHANGE_OFFER_AMOUNT: '/stock-exchange/offer-amount/:id',
  FAT_PROTEIN_PRICE: '/fat-protein-price',
  FAT_PROTEIN_PRICE_CREATE: '/fat-protein-price/create',
  FAT_PROTEIN_PRICE_EDIT: '/fat-protein-price/edit/:id',
  FAT_PROTEIN_PRICE_SHOW: '/fat-protein-price/show/:id',
  FAT_PROTEIN_PRICE_RESULTS: '/fat-protein-price/results/:id',
  FAT_PROTEIN_PRICE_PREVIEW: '/fat-protein-price/offers-preview/:id',
  FAT_PROTEIN_PRICE_OFFER_AMOUNT: '/fat-protein-price/offer-amount/:id',
  USERS_EDIT: '/users/edit/:id',
  USERS_SHOW: '/users/show/:id',
  SURVEY: '/survey',
  SURVEY_SHOW: '/survey/show/:id',
  SURVEY_SHOW_QUESTION_STATISTICS: '/survey/show/:id/statistic/question/:questionId',
  SURVEY_STATISTICS: '/survey/show/:id/statistic',
  SURVEY_RECREATE: '/survey/recreate/:id',
  SURVEY_SHOW_RESUTLS: '/survey/results/:id',
  SURVEY_SHOW_RESUTLS_ANSWERS: '/survey/results/:idSurvey/answers/:id',
  SURVEY_REQUEST_ENTRIES: '/survey/request-entries/:id',
  SURVEY_EDIT_ENTRIES: '/survey/request-entries/edit/:id',
  SURVEY_SHOW_ANSWERS: '/survey/answers/:idSurvey',
  SURVEY_SHOW_QUESTION_CREATE: '/survey/show/:id/question/create',
  SURVEY_SHOW_QUESTIONS_ADD: '/survey/show/:id/questions/add',
  SURVEY_QUESTIONS_PREVIEW: '/survey/:id/questions/preview',
  SURVEY_SHOW_QUESTION_SHOW: '/survey/show/:id/question/show/:idQuestion',
  SURVEY_SHOW_QUESTION_EDIT: '/survey/show/:id/question/edit/:idQuestion',
  SURVEY_EDIT: '/survey/edit/:id',
  SURVEY_CREATE: '/survey/create',
  NEWSLETTER: '/newsletter',
  NEWSLETTER_CREATE: '/newsletter/create',
  NEWSLETTER_EDIT: '/newsletter/edit/:id',
  NEWSLETTER_SHOW: '/newsletter/show/:id',
  FAQ: '/faq',
  FAQ_CREATE: '/faq/create',
  FAQ_EDIT: '/faq/groups/:id/edit',
  FAQ_SORT: '/faq/sort',
  FAQ_SORT_QUESTIONS: '/faq/groups/:id/sort',
  SETTINGS_FAQ: '/settings/builder-faq',
  FUTURE_CONTRACTS_TYPES: '/future-contracts/:contractsType',
  FUTURE_CONTRACTS_STONEX: '/future-contracts/stonex',
  FUTURE_CONTRACTS_TYPES_CHART: '/future-contracts/:contractsType/:symbol/:month/:year/chart',
  MANAGER_DASHBOARD: '/manager/dashboard',
  MANAGER_PROFILE: '/manager/profile',
  MANAGER_DELIVERIES: '/manager/deliveries',
  MANAGER_QUALITIES: '/manager/qualities',
  MANAGER_MILK_PAYMENTS: '/manager/milk-payments',
  MANAGER_CLIMATE_PROGRAM: '/manager/climate-program',
  MANAGER_CLIMATE_PROGRAM_PURCHASES: '/manager/climate-program/purchases',
  MANAGER_CLIMATE_PROGRAM_PURCHASE_CREATE: '/manager/climate-program/:idFarmer/purchase/create',
  MANAGER_CLIMATE_PROGRAM_PURCHASE_EDIT: '/manager/climate-program/purchase/:idFarmer/edit/:id',
  MANAGER_PROFILE_FARMERS: '/manager/profile/farmers',
  MANAGER_PROFILE_COLLECTION_POINTS: '/manager/profile/collection-points',
  MANAGER_PROFILE_REGISTRATIONS: '/manager/profile/registrations',
  MANAGER_PROFILE_REGISTRATION_ADD: '/manager/profile/:id/registration/add'
};
